import { cx } from '@vizit/theme';
import { Text, type TextProps, TextSize } from '../text';

interface AlertTitleProps extends TextProps {}

function AlertTitle(props: AlertTitleProps) {
  const { children, className, size = TextSize.Sm, ...other } = props;

  return (
    <Text className={cx('flex items-center gap-2 font-semibold text-secondary', className)} size={size} {...other}>
      {children}
    </Text>
  );
}

export { AlertTitle };
